/* pv-search.js — Vensaa-style search window (replaces Dawn's dropdown).
   Opens from the header search icon, shows live product results in a grid. */
(function () {
  var root = document.getElementById('pv-search');
  if (!root) return;
  var input = root.querySelector('.pvs__input');
  var status = root.querySelector('.pvs__status');
  var results = root.querySelector('.pvs__results');
  var allLink = root.querySelector('.pvs__all');
  var clearBtn = root.querySelector('[data-pvs-clear]');
  var cfgEl = document.getElementById('pv-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
  var moneyFormat = cfg.moneyFormat || '';
  var searchUrl = (window.routes && window.routes.search_url) || '/search';
  var suggestUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var timer = null, lastQ = '', ctrl = null, lastFocus = null;

  function money(major) {
    var n = parseFloat(major) || 0;
    var two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var none = Math.round(n).toLocaleString('en-US');
    if (!moneyFormat) return 'Rs.' + two;
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, none)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two)
      .replace(/\{\{\s*amount\s*\}\}/, two)
      .replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pvs-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); input.focus(); input.select(); });
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pvs-lock');
    setTimeout(function () { root.hidden = true; }, 180);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function reset() {
    results.innerHTML = '';
    status.textContent = 'Type to search products';
    allLink.hidden = true;
    clearBtn.hidden = true;
  }

  function render(q, products) {
    if (q !== input.value.trim()) return;
    var href = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product';
    allLink.href = href;
    allLink.textContent = 'View all results for “' + q + '”';
    if (!products.length) {
      status.textContent = 'No products found for “' + q + '”';
      results.innerHTML = '';
      allLink.hidden = true;
      return;
    }
    status.textContent = products.length + (products.length === 1 ? ' product found' : ' products found');
    results.innerHTML = products.map(function (p) {
      var imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
      var was = parseFloat(p.compare_at_price_max || 0), now = parseFloat(p.price || 0);
      return '<a class="pvs__card" href="' + esc(p.url) + '">' +
        '<span class="pvs__img">' + (imgUrl ? '<img src="' + esc(img(imgUrl, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') + '</span>' +
        '<span class="pvs__title">' + esc(p.title) + '</span>' +
        '<span class="pvs__price">' + esc(money(p.price)) + (was > now ? ' <s>' + esc(money(was)) + '</s>' : '') + '</span>' +
        '</a>';
    }).join('');
    allLink.hidden = false;
  }

  function search(q) {
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    status.textContent = 'Searching…';
    var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=8&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        render(q, list);
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') status.textContent = 'Search is unavailable right now. Press Enter to see all results.'; });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    clearTimeout(timer);
    if (!q) { lastQ = ''; reset(); return; }
    if (q === lastQ) return;
    lastQ = q;
    timer = setTimeout(function () { search(q); }, 220);
  });
  clearBtn.addEventListener('click', function () { input.value = ''; lastQ = ''; reset(); input.focus(); });
  root.addEventListener('click', function (e) { if (e.target.closest('[data-pvs-close]')) { e.preventDefault(); close(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  /* Take over the theme's search icon (desktop + mobile) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.header__search summary, a.header__icon--search, .header__icon--search');
    if (!trigger || root.contains(trigger)) return;
    e.preventDefault();
    e.stopPropagation();
    var details = trigger.closest('details');
    if (details) details.removeAttribute('open');
    open();
  }, true);

  reset();
})();
